import { createSlice } from '@reduxjs/toolkit'

const storedUser = localStorage.getItem('userData');

export const initialState = storedUser ? JSON.parse(storedUser) : {
    avatar: '',
    userName: '',
    email: '',
    authority: []
}

export const userSlice = createSlice({
	name: 'auth/user',
	initialState,
	reducers: {
        setUser: (_, action) => action.payload,
        userLoggedOut: () => initialState,
	},
})

export const { setUser } = userSlice.actions

export default userSlice.reducer